<div class="menuhome_main">
    <div class="menu_heading d-flex align-items-start">
      <div>
        <h4 class="fw-600 f-20 text-black">Merchants</h4>
        <p class="fw-500 pt-2 f-16">
          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
          nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat
          volutpat.
        </p>
      </div>
      <!-- <div>
        <i class="fa-solid fa-xmark f-24"></i>
      </div> -->
    </div>
    <div class="menu_box">
      <div class="menu_theme d-flex justify-content-between align-items-center" routerLink="/merchants">
        <div class="d-flex align-items-center gap-3">
          <div class="img_box">
            <img src="assets/images/Modifiers.png" alt="">
          </div>
          <div>
            <h5 class="fw-600 f-16 m-0">Merchants</h5>
            <p class="fw-500 f-16 txt_grey pt-2 m-0">
              Manage Merchants
            </p>
          </div>
        </div>
        <!-- <div>
          <i class="fa-solid fa-angle-right right_arrow"></i>
        </div> -->
      </div>
      <!-- <div class="menu_theme d-flex justify-content-between align-items-center" routerLink="/merchant-list">
          <div class="d-flex align-items-center gap-3">
            <div class="img_box">
                <img src="assets/images/Ingredients.png" alt="">
            </div>
            <div>
              <h5 class="fw-600 f-16 m-0">Merchants List</h5>
              <p class="fw-500 f-16 txt_grey pt-2 m-0">
                Make menu(s) for your restaurant
              </p>
            </div>
          </div>

        </div> -->
        <!-- <div class="menu_theme d-flex justify-content-between align-items-center" routerLink="/quick-setting">
          <div class="d-flex align-items-center gap-3">
            <div class="img_box">
                <img src="assets/images/add-on.png" alt="">
            </div>
            <div>
              <h5 class="fw-600 f-16 m-0">Quick Setting</h5>
              <p class="fw-500 f-16 txt_grey pt-2 m-0">
                Update Merchant Setting
              </p>
            </div>
          </div>
        </div> -->
    </div>
  </div>







<!-- <div class="menuhome_main">
  <div class="menu_heading d-flex align-items-start">
     <learn-more
      title="Competitive Price Analysis"
      link="https://support.eatos.com/en-us/article/how-to-access-the-guestbook-on-the-dashboard-cv2ndv/"
      content="Generation of dynamic and informative content."
    ></learn-more>
  </div>
  <div class="menu_box">
   <div
      (click)="activeClass()"
      class="menu_theme guest-border d-flex justify-content-between align-items-center"
      routerLink="/merchants/merchant-list"
    >
      <div class="d-flex align-items-center desire">
        <div class="img_box">
          <img
            src="assets/images/newsidemenu-image/default/dashboard.svg"
            alt=""
          />
        </div>
        <div>
          <h5 class="fw-600 f-16 m-0">{{ "Overview"  }}</h5>
          <p class="fw-500 txt_grey pt-2 m-0">
            {{ "Explore the magic of Maya. Create Menus. Generate Product images and much more with our in-house Generative Al" }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="menu_box">
    <div
      (click)="activeClass()"
      class="menu_theme guest-border d-flex justify-content-between align-items-center"
      routerLink="/merchants/merchant-details"
    >
      <div class="d-flex align-items-center desire">
        <div class="img_box">
          <img
            src="\assets\images\feature-page-image\Guest\Guest-Guestbook.svg"
            alt=""
          />
        </div>
        <div>
          <h5 class="fw-600 f-16 m-0">{{ "Course"  }}</h5>
          <p class="fw-500 txt_grey pt-2 m-0">
            {{ "Generation of dynamic and informative content." }}
          </p>
        </div>
      </div>
    </div>
  </div>

</div> -->

